import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const contactApi = {
  // Set auth token (for compatibility with AuthContext)
  setAuthToken: (token) => {
    // Token is already managed via localStorage in each method
    // This method exists for compatibility with AuthContext
    return;
  },

  // Submit the public "Contact Us" form (no authentication required)
  submitContactForm: async (formData) => {
    try {
      const payload = {
        fullName: formData.get('fullName'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        message: formData.get('message')
      };
      const response = await axios.post(
        `${API_URL}/api/contact/message`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to submit message' };
    }
  },

  // Submit a new contact request
  submitContactRequest: async (data) => {
    try {
      const token = localStorage.getItem('token');
      // console.log('Contact API Submit Data:', data);
      const response = await axios.post(
        `${API_URL}/api/contact/submit`,
        data,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, errors: ['Failed to submit request'] };
    }
  },

  // Get all contact requests for the logged-in company
  getMyContactRequests: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API_URL}/api/contact/my-requests`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch requests' };
    }
  },

  // Get a single contact request by ID
  getContactRequestById: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API_URL}/api/contact/request/${id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch request' };
    }
  },

  // Get all contact submissions (admin)
  getContactSubmissions: async (params = {}) => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams(params).toString();
      const response = await axios.get(
        `${API_URL}/api/contact/messages${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch contact submissions' };
    }
  },

  // Update status of a contact us message (admin)
  updateContactMessageStatus: async (id, status) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_URL}/api/contact/messages/${id}`,
        { status },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to update status' };
    }
  },

  // Get all company "Contact AID Office" requests (admin)
  getContactAIDRequests: async (params = {}) => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams(params).toString();
      const response = await axios.get(
        `${API_URL}/api/contact/requests${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch contact requests' };
    }
  },

  // Update status/response of a company contact request (admin)
  updateContactAIDRequest: async (id, { status, response: responseText }) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_URL}/api/contact/requests/${id}`,
        { status, response: responseText },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Contact API Error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to update contact request' };
    }
  }
};

export default contactApi;
